jQuery(window).load(function () {
  if (jQuery("#all").prop("checked") == true) {
    jQuery(".checkbox-option input").prop("checked", true);
    jQuery(".checkbox-option input").attr("checked", "checked");
  } else {
    jQuery(".checkbox-option input").prop("checked", false);

    jQuery(".checkbox-option input").removeAttr("checked");
  }

  //Has Focus JS
  jQuery("input, select, textarea, email, password, tel").each(function (
    index
  ) {
    var field = jQuery(this);
    field.on("focus", function () {
      jQuery(this).parent().addClass("has-focus");
    });

    field.on("focusout", function () {
      if (jQuery(this).val() == "") {
        jQuery(this).parent().removeClass("has-focus");
      }
    });
  });
  jQuery("input, select, textarea, email, password, tel").each(function (
    index
  ) {
    var field = jQuery(this);

    if (jQuery(this).val() != "") {
      jQuery(this).parent().addClass("has-focus");
    }
  });

  if (jQuery("#Email").val() == "") {
    jQuery(".newsletter-input").addClass("has-focus");
  } else {
    jQuery(".newsletter-input").removeClass("has-focus");
  }
});

jQuery(document).ready(function () {
  jQuery(".slider-for").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: ".slider-nav",
  });
  jQuery(".slider-nav").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".slider-for",
    dots: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
    ],
  });
  if (jQuery("body").hasClass("template-CollectionProducts")) {
    jQuery(".page-title h2 span.blue-text").text("ALL PRODUCTS");
    //jQuery(".breadcrumb-wrap .product").hide();
  }
  jQuery(".checkbox-option input").on("click", function () {
    console.log(jQuery(this).prop("checked"));
    var v_id = jQuery(this).attr("id");
    if (v_id != "all") {
      console.log(jQuery(this).attr("id"));
      if (jQuery(this).prop("checked") == false) {
        jQuery(".checkbox-option #all").prop("checked", false);

        jQuery(".checkbox-option #all").removeAttr("checked");
      }
    } else if (jQuery("#all").prop("checked") == true) {
      jQuery(".checkbox-option input").prop("checked", true);
      jQuery(".checkbox-option input").attr("checked", "checked");
    } else {
      jQuery(".checkbox-option input").prop("checked", false);
      jQuery(".checkbox-option input").removeAttr("checked");
    }
  });

  //Has Focus JS
  jQuery("input, select, textarea, email, password, tel").each(function (
    index
  ) {
    var field = jQuery(this);
    field.on("focus", function () {
      jQuery(this).parent().addClass("has-focus");
    });

    field.on("focusout", function () {
      if (jQuery(this).val() == "") {
        jQuery(this).parent().removeClass("has-focus");
      }
    });
  });
  jQuery("input, select, textarea, email, password, tel").each(function (
    index
  ) {
    var field = jQuery(this);

    if (jQuery(this).val() != "") {
      jQuery(this).parent().addClass("has-focus");
    }
  });

  if (jQuery("#Email").val() == "") {
    jQuery(".newsletter-input").addClass("has-focus");
  } else {
    jQuery(".newsletter-input").removeClass("has-focus");
  }

  //blog detail active menu
  if (jQuery("body").hasClass("template-Article")) {
    jQuery(".tt-mega_menu ul.tt_menus_ul li:nth-child(5)").addClass("active");
    jQuery("ul.inline-list li:nth-child(5)").addClass("active");
  }

  //Menu Active
  var url = window.location.pathname;
  var activePage = url.substring(url.lastIndexOf("/") + 1);

  // Handle main menu items
  $(".tt_menus_ul li a").each(function () {
    var linkPage = this.href.substring(this.href.lastIndexOf("/") + 1);

    if (activePage == linkPage) {
      //$(this).addClass('active');
      $(this).closest(".tt_menus_ul li").addClass("active"); // Add active class to the parent menu item
    }
  });

  // Handle submenu items
  $(".tt_menus_ul .tt_sub_menu_wrap a").each(function () {
    var subLinkPage = this.href.substring(this.href.lastIndexOf("/") + 1);

    if (activePage == subLinkPage) {
      $(this).parent().parent().addClass("active");
      $(this).closest(".tt_menus_ul li").addClass("active"); // Add active class to the parent menu item
    }
  });

  $(document).ready(function () {
    var url = window.location.pathname;
    var activePage = url.substring(url.lastIndexOf("/") + 1);

    // Handle main menu items
    $("ul.inline-list li a").each(function () {
      var linkPage = this.href.substring(this.href.lastIndexOf("/") + 1);

      if (activePage == linkPage) {
        //$(this).addClass('active');
        $(this).closest("ul.inline-list li").addClass("active"); // Add active class to the parent menu item
      }
    });
  });

  //Home page Slider
  if (jQuery(window).width() <= 767) {
    jQuery(".TTProduct-Tabs.for-mobile.owl-carousel .grid-item").owlCarousel({
      loop: true,
      margin: 10,
      nav: true,
      responsive: {
        // breakpoint from 0 up
        0: {
          items: 1,
        },
        480: {
          items: 1,
        },
        768: {
          items: 1,
        },
      },
    });
  }
  //Instagram CArousel
  jQuery(".cms-gallery .image-content").owlCarousel({
    loop: true,
    margin: 10,
    nav: true,
    responsive: {
      // breakpoint from 0 up
      0: {
        items: 1,
      },
      480: {
        items: 1,
      },
      667: {
        items: 2,
      },
      768: {
        items: 2,
      },
      1023: {
        items: 2,
      },
      1024: {
        items: 3,
      },
    },
  });

  //Mobile tabbing JS
  jQuery(".tab-btn.mobile1").click(function () {
    if (jQuery(".tab-btn.mobile1").hasClass("active")) {
      jQuery(".TTProduct-Tabs.for-mobile .mobile1").addClass("active");
      jQuery(".TTProduct-Tabs.for-mobile .mobile2").removeClass("active");
      jQuery(".TTProduct-Tabs.for-mobile .mobile3").removeClass("active");
    }
  });
  jQuery(".tab-btn.mobile2").click(function () {
    if (jQuery(".tab-btn.mobile2").hasClass("active")) {
      jQuery(".TTProduct-Tabs.for-mobile .mobile2").addClass("active");
      jQuery(".TTProduct-Tabs.for-mobile .mobile3").removeClass("active");
      jQuery(".TTProduct-Tabs.for-mobile .mobile1").removeClass("active");
    }
  });
  jQuery(".tab-btn.mobile3").click(function () {
    if (jQuery(".tab-btn.mobile3").hasClass("active")) {
      jQuery(".TTProduct-Tabs.for-mobile .mobile3").addClass("active");
      jQuery(".TTProduct-Tabs.for-mobile .mobile1").removeClass("active");
      jQuery(".TTProduct-Tabs.for-mobile .mobile2").removeClass("active");
    }
  });

  //Contact Form JS
  jQuery(".btn-contact").on("click", function (e) {
    jQuery(".error-msg").hide();
    var fname = jQuery("#contactFormName").val();
    var ffone = jQuery("#contactFormPhone").val();
    var femail = jQuery("#contactFormEmail").val();
    var fmsg = jQuery("#contactFormMessage").val();
    var test_pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
    var phone_pattern = /([0-9]{10})|(\([0-9]{3}\)\s+[0-9]{3}\-[0-9]{4})/;
    var fflag,
      mflag,
      emailflag,
      passflag,
      nflag = 0;

    if (fname == "") {
      jQuery("#contactFormName").addClass("input-error");
      jQuery(".error-fname").show();
      jQuery("<p class='error-msg'>Please enter your Name.</p>").insertAfter(
        "#contactFormName"
      );
      e.preventDefault();
      fflag = 1;
    } else {
      jQuery("#contactFormName").removeClass("input-error");
      jQuery(".error-fname").hide();
    }

    if (ffone == "") {
      emailflag = 1;
      jQuery("#contactFormPhone").addClass("error");
      jQuery(
        "<p class='error-msg'>Please enter your Phone Number.</p>"
      ).insertAfter("#contactFormPhone");
      e.preventDefault();
    } else {
      if (!phone_pattern.test(ffone)) {
        emailflag = 1;
        jQuery(".error-ffone").show();
        jQuery("#contactFormPhone").addClass("error");
        jQuery(
          "<p class='error-msg'>Please enter Number not Text</p>"
        ).insertAfter("#contactFormPhone");
        e.preventDefault();
      } else {
        jQuery(".error-ffone").hide();
        jQuery("#contactFormPhone").removeClass("error");
      }
    }

    if (fmsg == "") {
      jQuery("#contactFormMessage").addClass("error");
      jQuery(".error-fmsg").show();
      jQuery("<p class='error-msg'>Please enter your Message.</p>").insertAfter(
        "#contactFormMessage"
      );
      e.preventDefault();
      mflag = 1;
    } else {
      jQuery("#contactFormMessage").removeClass("error");
      jQuery(".error-fmsg").hide();
    }

    if (femail == "") {
      emailflag = 1;
      jQuery("#contactFormEmail").addClass("error");
      jQuery("<p class='error-msg'>Please enter your Email.</p>").insertAfter(
        "#contactFormEmail"
      );
      e.preventDefault();
    } else {
      if (!test_pattern.test(femail)) {
        emailflag = 1;
        jQuery(".error-email").show();
        jQuery("#contactFormEmail").addClass("error");
        jQuery(
          "<p class='error-msg'>The email address entered is invalid.</p>"
        ).insertAfter("#contactFormEmail");
        e.preventDefault();
      } else {
        jQuery(".error-email").hide();
        jQuery("#contactFormEmail").removeClass("error");
      }
    }

    if (fflag == 1) {
      jQuery(
        "<p class='error-msg last-btn-error'>One or more fields have an error. Please check and try again.</p>"
      ).insertAfter(".btn-contact");
      e.preventDefault();
      return false;
    } else {
      return true;
    }
  });
  jQuery(".btn-contact").click(function () {
    jQuery(".form-success").hide();
  });

  // Login JS
  jQuery(".login-btn").on("click", function (e) {
    jQuery(".error-msg").hide();
    var femail = jQuery("#customer_email").val();
    var fpswd = jQuery("#customer_password").val();
    var test_pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
    var fflag,
      mflag,
      emailflag,
      passflag,
      nflag = 0;

    if (fpswd == "") {
      jQuery("#customer_password").addClass("error");
      jQuery(".error-fpswd").show();
      jQuery("<p class='error-msg'>Please enter your Message.</p>").insertAfter(
        "#customer_password"
      );
      e.preventDefault();
      fflag = 1;
    } else {
      jQuery("#customer_password").removeClass("error");
      jQuery(".error-fpswd").hide();
    }

    if (femail == "") {
      emailflag = 1;
      jQuery("#customer_email").addClass("error");
      jQuery("<p class='error-msg'>Please enter your Email.</p>").insertAfter(
        "#customer_email"
      );
      fflag = 1;
      e.preventDefault();
    } else {
      if (!test_pattern.test(femail)) {
        emailflag = 1;
        jQuery(".error-email").show();
        jQuery("#customer_email").addClass("error");
        jQuery(
          "<p class='error-msg'>The email address entered is invalid.</p>"
        ).insertAfter("#customer_email");
        e.preventDefault();
        fflag = 1;
      } else {
        jQuery(".error-email").hide();
        jQuery("#customer_email").removeClass("error");
      }
    }

    if (fflag == 1) {
      jQuery(
        "<p class='error-msg last-btn-error'>One or more fields have an error. Please check and try again.</p>"
      ).insertAfter(".login-btn");
      e.preventDefault();
      return false;
    } else {
      return true;
    }
  });

  //Register JS
  jQuery(".register-btn").on("click", function (e) {
    jQuery(".error-msg").hide();
    var fname = jQuery("#first_name").val();
    var fname = jQuery("#last_name").val();
    var femail = jQuery("#email").val();
    var fpswd = jQuery("#create_password").val();
    var test_pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
    var fflag,
      mflag,
      emailflag,
      passflag,
      nflag = 0;

    if (fpswd == "") {
      jQuery("#create_password").addClass("error");
      jQuery(".error-fpswd").show();
      jQuery("<p class='error-msg'>Please enter your Message.</p>").insertAfter(
        "#create_password"
      );
      e.preventDefault();
      fflag = 1;
    } else {
      jQuery("#create_password").removeClass("error");
      jQuery(".error-fpswd").hide();
    }

    if (femail == "") {
      emailflag = 1;
      jQuery("#email").addClass("error");
      jQuery("<p class='error-msg'>Please enter your Email.</p>").insertAfter(
        "#email"
      );
      fflag = 1;
      e.preventDefault();
    } else {
      if (!test_pattern.test(femail)) {
        emailflag = 1;
        jQuery(".error-email").show();
        jQuery("#email").addClass("error");
        jQuery(
          "<p class='error-msg'>The email address entered is invalid.</p>"
        ).insertAfter("#email");
        e.preventDefault();
        fflag = 1;
      } else {
        jQuery(".error-email").hide();
        jQuery("#email").removeClass("error");
      }
    }

    if (fname == "") {
      jQuery("#first_name").addClass("input-error");
      jQuery(".error-fname").show();
      jQuery("<p class='error-msg'>Please enter your Name.</p>").insertAfter(
        "#first_name"
      );
      e.preventDefault();
      fflag = 1;
    } else {
      jQuery("#first_name").removeClass("input-error");
      jQuery(".error-fname").hide();
    }

    if (fname == "") {
      jQuery("#last_name").addClass("input-error");
      jQuery(".error-fname").show();
      jQuery("<p class='error-msg'>Please enter your Phone.</p>").insertAfter(
        "#last_name"
      );
      e.preventDefault();
      nflag = 1;
    } else {
      jQuery("#last_name").removeClass("input-error");
      jQuery(".error-fname").hide();
    }

    if (fflag == 1) {
      jQuery(
        "<p class='error-msg last-btn-error'>One or more fields have an error. Please check and try again.</p>"
      ).insertAfter(".register-btn");
      e.preventDefault();
      return false;
    } else {
      return true;
    }
  });

  //Forget Password JS
  jQuery(".forget-btn").on("click", function (e) {
    jQuery(".error-msg").hide();
    var femail = jQuery("#recover-email").val();
    var test_pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
    var fflag = 0;

    if (femail == "") {
      emailflag = 1;
      jQuery("#recover-email").addClass("error");
      jQuery("<p class='error-msg'>Please enter your Email.</p>").insertAfter(
        "#recover-email"
      );
      fflag = 1;
      e.preventDefault();
    } else {
      if (!test_pattern.test(femail)) {
        emailflag = 1;
        jQuery(".error-email").show();
        jQuery("#recover-email").addClass("error");
        jQuery(
          "<p class='error-msg'>The email address entered is invalid.</p>"
        ).insertAfter("#recover-email");
        e.preventDefault();
        fflag = 1;
      } else {
        jQuery(".error-email").hide();
        jQuery("#recover-email").removeClass("error");
      }
    }

    if (fflag == 1) {
      jQuery(
        "<p class='error-msg last-btn-error'>One or more fields have an error. Please check and try again.</p>"
      ).insertAfter(".forget-btn");
      e.preventDefault();
      return false;
    } else {
      return true;
    }
  });

  // Reset Password JS
  jQuery(".reset-pass-btn").click(function (e) {
    jQuery(".error-msg").hide();
    var password = jQuery("#reset_password").val();
    var PasswortBest = jQuery("#password_confirmation").val();
    var test_pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
    var passflag,
      fflag,
      conformpass = 0;

    if (password == "") {
      passflag = 1;
      jQuery("#reset_password").addClass("input--error");
      jQuery("error-pass").show();
      jQuery(
        "<p class='error-msg'>Please enter your Password.</p>"
      ).insertAfter("#reset_password");
      e.preventDefault();
      fflag = 1;
    } else {
      jQuery("#reset_password").removeClass("input--error");
      jQuery(".error-pass").hide();
    }
    if (PasswortBest == "") {
      conformpass = 1;
      jQuery("#password_confirmation").addClass("input--error");
      jQuery(".error-passwordbest").show();
      jQuery(
        "<p class='error-msg'>Please enter your Confirm Password.</p>"
      ).insertAfter("#password_confirmation");
      e.preventDefault();
      fflag = 1;
    } else {
      if (password != PasswortBest) {
        jQuery("#password_confirmation").addClass("input--error");
        jQuery("#reset_password").addClass("input--error");
        var con_passwd_err = 2;
        jQuery(
          "<p class='error-msg'>Password and confirmation password does not match.</p>"
        ).insertAfter("#password_confirmation");
        e.preventDefault();
        fflag = 1;
      } else {
        jQuery("#RegisterForm #RegisterForm-PasswortBestätigen").removeClass(
          "input--error"
        );
        con_passwd_err = 0;
        jQuery("#reset_password").removeClass("input--error");

        jQuery(".error-passwordbest").hide();
      }
    }

    if (fflag == 1) {
      jQuery(
        "<p class='error-msg last-btn-error'>One or more fields have an error. Please check and try again.</p>"
      ).insertAfter(".reset-pass-btn");
      e.preventDefault();
      return false;
    } else {
      return true;
    }
  });

  //Add Address JS
  jQuery(".add-address").on("click", function (e) {
    jQuery(".error-msg").hide();
    var fname = jQuery("#address_first_name_new").val();
    var lname = jQuery("#address_last_name_new").val();
    var ffone = jQuery("#address_phone_new").val();
    var address = jQuery("#address_address1_new").val();
    var city = jQuery("#address_city_new").val();
    var zip = jQuery("#address_zip_new").val();
    //var test_pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
    var phone_pattern = /([0-9]{10})|(\([0-9]{3}\)\s+[0-9]{3}\-[0-9]{4})/;
    var fflag,
      mflag,
      emailflag,
      passflag,
      nflag = 0;

    if (fname == "") {
      jQuery("#address_first_name_new").addClass("error");
      jQuery(".error-fname").show();
      jQuery(
        "<p class='error-msg'>Please enter your First Name.</p>"
      ).insertAfter("#address_first_name_new");
      e.preventDefault();
      fflag = 1;
    } else {
      jQuery("#address_first_name_new").removeClass("error");
      jQuery(".error-fname").hide();
    }

    if (lname == "") {
      jQuery("#address_last_name_new").addClass("error");
      jQuery(".error-lname").show();
      jQuery(
        "<p class='error-msg'>Please enter your Last Name.</p>"
      ).insertAfter("#address_last_name_new");
      e.preventDefault();
      nflag = 1;
    } else {
      jQuery("#address_last_name_new").removeClass("error");
      jQuery(".error-lname").hide();
    }

    if (address == "") {
      jQuery("#address_address1_new").addClass("error");
      jQuery(".error-address").show();
      jQuery("<p class='error-msg'>Please enter your Address.</p>").insertAfter(
        "#address_address1_new"
      );
      e.preventDefault();
      nflag = 1;
    } else {
      jQuery("#address_address1_new").removeClass("error");
      jQuery(".error-address").hide();
    }

    if (ffone == "") {
      emailflag = 1;
      jQuery("#address_phone_new").addClass("error");
      jQuery(
        "<p class='error-msg'>Please enter your Phone Number.</p>"
      ).insertAfter("#address_phone_new");
      e.preventDefault();
    } else {
      if (!phone_pattern.test(ffone)) {
        emailflag = 1;
        jQuery(".error-ffone").show();
        jQuery("#address_phone_new").addClass("error");
        jQuery(
          "<p class='error-msg'>Please enter Number not Text</p>"
        ).insertAfter("#address_phone_new");
        e.preventDefault();
      } else {
        jQuery(".error-ffone").hide();
        jQuery("#address_phone_new").removeClass("error");
      }
    }

    if (city == "") {
      jQuery("#address_city_new").addClass("error");
      jQuery(".error-city").show();
      jQuery("<p class='error-msg'>Please enter your City.</p>").insertAfter(
        "#address_city_new"
      );
      e.preventDefault();
      mflag = 1;
    } else {
      jQuery("#address_city_new").removeClass("error");
      jQuery(".error-city").hide();
    }

    if (zip == "") {
      jQuery("#address_zip_new").addClass("error");
      jQuery(".error-zip").show();
      jQuery(
        "<p class='error-msg'>Please enter your Zip Code.</p>"
      ).insertAfter("#address_zip_new");
      e.preventDefault();
      mflag = 1;
    } else {
      jQuery("#address_zip_new").removeClass("error");
      jQuery(".error-zip").hide();
    }

    if (fflag == 1) {
      jQuery(
        "<p class='error-msg last-btn-error'>One or more fields have an error. Please check and try again.</p>"
      ).insertAfter(".save-btn");
      e.preventDefault();
      return false;
    } else {
      return true;
    }
  });
  jQuery(".search-submit").on("click", function (e) {
    jQuery(".error-msg").hide();
    var search = jQuery("#searchBox").val();
    var fflag = 0;

    if (search == "") {
      jQuery("#searchBox").addClass("error");
      jQuery(".error-search").show();
      jQuery("<p class='error-msg'>The field is blank.</p>").insertAfter(
        "#searchBox"
      );
      e.preventDefault();
      fflag = 1;
    } else {
      jQuery("#searchBox").removeClass("error");
      jQuery(".error-search").hide();
    }
  });
  jQuery(".subscribe").on("click", function (e) {
    jQuery(".error-msg").hide();
    var news = jQuery("#contact_form #Email").val();
    var fflag = 0;

    if (news == "") {
      jQuery("#contact_form #Email").addClass("error");
      jQuery(".error-email").show();
      jQuery("<p class='error-msg'>Email can't be blank.</p>").insertAfter(
        ".ttinput_newsletter"
      );
      e.preventDefault();
      fflag = 1;
    } else {
      jQuery("#contact_form #Email").removeClass("error");
      jQuery(".error-email").hide();
    }
  });

  //remove Tooltip
  jQuery(
    ".widget_top_rated_products ul.top-products li.vendor-list h3 a"
  ).removeAttr("title");

  //active collection List in collection page
  // jQuery(".collection-list.Conditioner").addClass("active-collection");
  // jQuery(".collection-list").on("click", function () {
  //   // Remove class from oldest li
  //   jQuery(".collection-list.active-collection").removeClass(
  //     "active-collection"
  //   );

  //   // Add class to clicked li
  //   jQuery(this).addClass("active-collection");
  // });

  var url = window.location.href;
  console.log(url);
  var splitUrl = url.split("https://nybmiami-dev.myshopify.com");
  var hrefValues = [];

  $(".product-categories a").each(function () {
    var data = $(this).attr("href");
    var arr = data.split("/");
    var url1 = url.split("/");
    console.log(arr[2] + "---------------" + url1[4]);
    if (arr[2] == url1[4]) {
      $(this).addClass("active");
    }
  });
});
